import styled from '@emotion/styled'
import * as React from 'react'

import { HamburgerIcon, palette, spacing } from 'main/ui'

const Container = styled.button`
  background: transparent;
  border: none;
  color: ${palette.mediumGray};
  cursor: pointer;
  height: 25px;
  margin-right: ${spacing.majorScale(2)}px;
  outline: none;
  padding: 0;
  width: 25px;
`

interface IProps {
  onClick: () => void
}

function Hamburger(props: IProps) {
  const { onClick } = props

  return (
    <Container onClick={onClick}>
      <HamburgerIcon />
    </Container>
  )
}

export default React.memo(Hamburger)
